export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/ad_copy.4758359.svg";